import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import RouterLink from '../../util/RouterLink';
import { connect } from 'react-redux';
import { Box, Button, TextField } from '@mui/material';
import * as authenticateActions from '../../actions/authenticateActions';
import { notify } from '../../util/notifications';
import AuthLayout from './AuthLayout';

class ForgetPassword extends Component {
    state = { userName: '', submitted: false, sending: false };

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ submitted: true });
        if (!this.state.userName.trim()) return;
        const { dispatch, history } = this.props;
        this.setState({ sending: true });
        dispatch(
            authenticateActions.forgetPassword(
                this.state.userName.trim(),
                () => {
                    notify.createNotification('success', 'Check your email for a link to reset your password.', this.props.refNotify);
                    history.push('/login');
                },
                () => {
                    this.setState({ sending: false });
                    notify.createNotification('error', "The reset email couldn't be sent. Contact your administrator.", this.props.refNotify);
                }
            )
        );
    };

    render() {
        const { userName, submitted, sending } = this.state;
        const error = submitted && !userName.trim() ? 'Enter your email' : '';
        return (
            <AuthLayout title="Reset your password" subtitle="Enter your email and we'll send you a link to set a new password.">
                <Box component="form" noValidate onSubmit={this.handleSubmit} sx={{ display: 'grid', gap: 2 }}>
                    <TextField
                        label="Email"
                        type="email"
                        autoComplete="email"
                        autoFocus
                        size="medium"
                        value={userName}
                        onChange={(e) => this.setState({ userName: e.target.value })}
                        error={Boolean(error)}
                        helperText={error}
                    />
                    <Button type="submit" variant="contained" size="large" disabled={sending}>
                        {sending ? 'Sending…' : 'Send reset link'}
                    </Button>
                    <Button component={RouterLink} to="/login" variant="text">
                        Back to sign in
                    </Button>
                </Box>
            </AuthLayout>
        );
    }
}

const mapStateToProps = (state) => ({ authInfo: state.authInfo, refNotify: state.refNotify });

export default withRouter(connect(mapStateToProps)(ForgetPassword));
